import validator from "validator";
import { CreateDeliveryPayload } from "../../types/delivery/delivery-payload";

export interface DeliveryPayloadValidator {
  clientId: boolean;
  agencyId: boolean;
  dateToWork: boolean;
  loadName: boolean;
  // loadQuantity: boolean;
  pickUpAddress: boolean;
  pickUpActionStartTimeLimited: boolean;
  pickUpActionEndTimeLimited: boolean;
  // pickUpActionRequirement: boolean;
  // pickUpWorkPlaceName: boolean;
  // pickUpWorkPlaceFloor: boolean;
  // pickUpWorkPlacePhone: boolean;
  pickUpWorkPlaceDetail: boolean;
  dropOffAddress: boolean;
  dropOffActionStartTimeLimited: boolean;
  dropOffActionEndTimeLimited: boolean;
  // dropOffActionRequirement: boolean;
  // dropOffWorkPlaceName: boolean;
  // dropOffWorkPlaceFloor: boolean;
  // dropOffWorkPlacePhone: boolean;
  dropOffWorkPlaceDetail: boolean;
}

export const validateDeliveryPayload = (
  createDeliveryPayload: CreateDeliveryPayload
) => {
  const clientId = validator.isEmpty(createDeliveryPayload.clientId || "");
  const agencyId = validator.isEmpty(createDeliveryPayload.agencyId || "");
  const dateToWork = validator.isEmpty(createDeliveryPayload.dateToWork);
  const loadName = validator.isEmpty(createDeliveryPayload.load.name || "");
  // const loadQuantity = validator.isEmpty(
  //   String(createDeliveryPayload.load.quantity)
  // );
  const pickUpAddress = validator.isEmpty(createDeliveryPayload.pickUpAddress);
  const pickUpActionStartTimeLimited = validator.isEmpty(
    createDeliveryPayload.pickUpAction.startTimeLimited
  );
  const pickUpActionEndTimeLimited = validator.isEmpty(
    createDeliveryPayload.pickUpAction.endTimeLimited
  );
  // const pickUpActionRequirement = validator.isEmpty(
  //   createDeliveryPayload.pickUpAction.requirement || ""
  // );
  // const pickUpWorkPlaceName = validator.isEmpty(
  //   createDeliveryPayload.pickUpWorkPlace.name || ""
  // );
  // const pickUpWorkPlaceFloor = validator.isEmpty(
  //   String(createDeliveryPayload.pickUpWorkPlace.floor)
  // );
  // const pickUpWorkPlacePhone = validator.isEmpty(
  //   createDeliveryPayload.pickUpWorkPlace.phone || ""
  // );
  const pickUpWorkPlaceDetail = validator.isEmpty(
    createDeliveryPayload.pickUpWorkPlace.detail
  );
  const dropOffAddress = validator.isEmpty(
    createDeliveryPayload.dropOffAddress
  );
  const dropOffActionStartTimeLimited = validator.isEmpty(
    createDeliveryPayload.dropOffAction.startTimeLimited
  );
  const dropOffActionEndTimeLimited = validator.isEmpty(
    createDeliveryPayload.dropOffAction.endTimeLimited
  );
  // const dropOffActionRequirement = validator.isEmpty(
  //   createDeliveryPayload.dropOffAction.requirement || ""
  // );
  // const dropOffWorkPlaceName = validator.isEmpty(
  //   createDeliveryPayload.dropOffWorkPlace.name || ""
  // );
  // const dropOffWorkPlaceFloor = validator.isEmpty(
  //   String(createDeliveryPayload.dropOffWorkPlace.floor)
  // );
  // const dropOffWorkPlacePhone = validator.isEmpty(
  //   createDeliveryPayload.dropOffWorkPlace.phone || ""
  // );
  const dropOffWorkPlaceDetail = validator.isEmpty(
    createDeliveryPayload.dropOffWorkPlace.detail
  );
  return {
    hasError:
      clientId ||
      agencyId ||
      dateToWork ||
      loadName ||
      // loadQuantity ||
      pickUpAddress ||
      pickUpActionStartTimeLimited ||
      pickUpActionEndTimeLimited ||
      // pickUpActionRequirement ||
      // pickUpWorkPlaceName ||
      // pickUpWorkPlaceFloor ||
      // pickUpWorkPlacePhone ||
      pickUpWorkPlaceDetail ||
      dropOffAddress ||
      dropOffActionStartTimeLimited ||
      dropOffActionEndTimeLimited ||
      // dropOffActionRequirement ||
      // dropOffWorkPlaceName ||
      // dropOffWorkPlaceFloor ||
      // dropOffWorkPlacePhone ||
      dropOffWorkPlaceDetail,
    validationResults: {
      clientId,
      agencyId,
      dateToWork,
      loadName,
      // loadQuantity,
      pickUpAddress,
      pickUpActionStartTimeLimited,
      pickUpActionEndTimeLimited,
      // pickUpActionRequirement,
      // pickUpWorkPlaceName,
      // pickUpWorkPlaceFloor,
      // pickUpWorkPlacePhone,
      pickUpWorkPlaceDetail,
      dropOffAddress,
      dropOffActionStartTimeLimited,
      dropOffActionEndTimeLimited,
      // dropOffActionRequirement,
      // dropOffWorkPlaceName,
      // dropOffWorkPlaceFloor,
      // dropOffWorkPlacePhone,
      dropOffWorkPlaceDetail,
    },
  };
};
